import React from "react";
import { InputAdornment, TextField, Tooltip } from "@mui/material";

import { NearbyAlertsBound, humanizeField } from "./nearbyAlerts";

interface PropsInterface {
  bound: NearbyAlertsBound;
  value: string;
  error?: string;
  disabled: boolean;
  onChange: (field: string, value: string) => void;
}

export const NearbyAlertsField: React.FC<PropsInterface> = ({
  bound,
  value,
  error,
  disabled,
  onChange,
}) => (
  <Tooltip title={bound.description} placement="top-start">
    <TextField
      size="small"
      fullWidth
      type="number"
      label={humanizeField(bound)}
      value={value}
      disabled={disabled}
      error={Boolean(error)}
      // Range, step, placeholder and help text all come from the payload — a
      // literal here is how the form starts disagreeing with the validator.
      helperText={error ?? `${bound.min}–${bound.max} · default ${bound.defaultValue}`}
      placeholder={String(bound.defaultValue)}
      inputProps={{
        min: bound.min,
        max: bound.max,
        step: bound.integer ? 1 : "any",
        "aria-label": humanizeField(bound),
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">{bound.unit}</InputAdornment>
        ),
      }}
      onChange={(event) => onChange(bound.field, event.target.value)}
    />
  </Tooltip>
);
